import AddConnector from './AddConnector.vue'
import AddContactIcon from './AddContactIcon.vue'
import Agent from './Agent.vue'
import AnalyticsIcon from './AnalyticsIcon.vue'
import AngleDoubleRightSolidIcon from './AngleDoubleRightSolidIcon.vue'
import AppDeviceIcon from './AppDeviceIcon.vue'
import Arrow from './Arrow.vue'
import ArrowCircleLeftSolidIcon from './ArrowCircleLeftSolidIcon.vue'
import Back from './Back.vue'
import CalendarSwitch from './CalendarSwitch.vue'
import CallForwardingIcon from './CallForwardingIcon.vue'
import CaretDownIcon from './CaretDownIcon.vue'
import CaretDownSolidIcon from './CaretDownSolidIcon.vue'
import CaretUpSolidIcon from './CaretUpSolidIcon.vue'
import CatchAllIcon from './CatchAllIcon.vue'
import CfcIcon from './CfcIcon.vue'
import CheckCircleSolidIcon from './CheckCircleSolidIcon.vue'
import Checkmark from './Checkmark.vue'
import CheckmarkInCircle from './CheckmarkInCircle.vue'
import CheckSolidIcon from './CheckSolidIcon.vue'
import Chevron from './Chevron.vue'
import ChevronLeft from './ChevronLeft.vue'
import ChevronRight from './ChevronRight.vue'
import CloneIcon from './CloneIcon.vue'
import Close from './Close.vue'
import CloudIcon from './CloudIcon.vue' //not used
import CogSolidIcon from './CogSolidIcon.vue'
import CollapseIcon from './CollapseIcon.vue'
import Copy from './Copy.vue'
import Cursor from './Cursor.vue'
import Decrease from './Decrease.vue'
import DectBaseDeviceIcon from './DectBaseDeviceIcon.vue'
import DectHandsetDeviceIcon from './DectHandsetDeviceIcon.vue'
import Delete from './Delete.vue'
import DocumentFileRounded from './DocumentFileRounded.vue'
import DottedSpinner from './DottedSpinner.vue'
import DownloadContactsIcon from './DownloadContactsIcon.vue'
import EasybellLogo from './EasybellLogo.vue'
import EasyLogoIcon from './EasyLogoIcon.vue'
import EbCalling0Icon from './EbCalling0Icon.vue'
import EbCalling1Icon from './EbCalling1Icon.vue'
import EbConferenceIcon from './EbConferenceIcon.vue'
import EbFax2EmailIcon from './EbFax2EmailIcon.vue'
import EbQueueIcon from './EbQueueIcon.vue'
import EbFqdnIcon from './EbFqdnIcon.vue'
import ErrorIcon from './ErrorIcon.vue'
import ErrorCircle from './ErrorCircle.vue'
import ExclamationTriangleSolidIcon from './ExclamationTriangleSolidIcon.vue'
import ExternalDeviceIcon from './ExternalDeviceIcon.vue'
import FacebookIcon from './FacebookIcon.vue'
import FilterIcon from './FilterIcon.vue'
import Folder from './Folder.vue'
import Forward from './Forward.vue'
import Hand from './Hand.vue'
import Home from './Home.vue'
import Increase from './Increase.vue'
import InfoIcon from './InfoIcon.vue'
import InfoCircle from './InfoCircle.vue'
import InstagramIcon from './InstagramIcon.vue'
import ItemsPlus from './ItemsPlus.vue'
import LinkedinIcon from './LinkedinIcon.vue'
import MailIcon from './MailIcon.vue'
import ModuleBig from './ModuleBig.vue'
import Modules from './Modules.vue'
import ModuleSmall from './ModuleSmall.vue'
import MultiEdit from './MultiEdit.vue'
import MusicOnHoldIcon from './MusicOnHoldIcon.vue'
import NightSwitchIcon from './NightSwitchIcon.vue'
import Note from './Note.vue'
import NotificationIcon from './NotificationIcon.vue'
import OfficeDeskIcon from './OfficeDeskIcon.vue'
import PencilMini from './PencilMini.vue'
import PencilMiniActive from './PencilMiniActive.vue'
import PenIcon from './PenIcon.vue'
import PhoneAltSolidIcon from './PhoneAltSolidIcon.vue'
import PlayIcon from './PlayIcon.vue'
import Plus from './Plus.vue'
import PlusCircleSolidIcon from './PlusCircleSolidIcon.vue'
import PlusConnector from './PlusConnector.vue'
import PlusSolidIcon from './PlusSolidIcon.vue'
import PrimaryDectBaseDeviceIcon from './PrimaryDectBaseDeviceIcon.vue'
import Question from './Question.vue'
import Redo from './Redo.vue'
import RefreshIcon from './RefreshIcon.vue'
import RemoveContactIcon from './RemoveContactIcon.vue'
import RemoveColorIcon from './RemoveColorIcon.vue'
import SaveSolidIcon from './SaveSolidIcon.vue'
import Search from './Search.vue'
import SecondaryDectBaseDeviceIcon from './SecondaryDectBaseDeviceIcon.vue'
import SelectAllIcon from './SelectAllIcon.vue'
import Separator from './Separator.vue'
import SeparatorVertical from './SeparatorVertical.vue'
import SettingsIcon from './SettingsIcon.vue'
import SignOutAltSolidIcon from './SignOutAltSolidIcon.vue'
import StopIcon from './StopIcon.vue'
import SuccessIcon from './SuccessIcon.vue'
import SuccessCircle from './SuccessCircle.vue'
import TeamsDeviceIcon from './TeamsDeviceIcon.vue'
import ConnectMeDeviceIcon from './ConnectMeDeviceIcon.vue'
import TimesSolidIcon from './TimesSolidIcon.vue'
import TrashIcon from './TrashIcon.vue'
import TrashSolidIcon from './TrashSolidIcon.vue'
import TwitterIcon from './TwitterIcon.vue'
import Undo from './Undo.vue'
import UploadContactsIcon from './UploadContactsIcon.vue'
import VoiceMailIcon from './VoiceMailIcon.vue'
import VoipDeviceIcon from './VoipDeviceIcon.vue'
import WaitingMusicIcon from './WaitingMusicIcon.vue'
import WaitLoopIcon from './WaitLoopIcon.vue'
import WarningIcon from './WarningIcon.vue'
import WarningCircle from './WarningCircle.vue'
import YoutubeIcon from './YoutubeIcon.vue'
import Contacts from './Contacts.vue'
import Lightbulb from './Lightbulb.vue'
import KebabMenu from './KebabMenu.vue'
import EntraIcon from './EntraIcon.vue'
import Spinner from '../Spinner.vue'
import FolderArrowUp from './FolderArrowUp.vue'

import Phone from './Phone.vue'
import Playback from './cfc/Playback.vue'
import Queue from './cfc/Queue.vue'
import PressDigit from './cfc/PressDigit.vue'
import TimeSwitch from './cfc/TimeSwitch.vue'
import ManualSwitch from './cfc/ManualSwitch.vue'
import Voicemail from './cfc/Voicemail.vue'
import CallerID from './cfc/CallerID.vue'
import QueuePriority from './cfc/QueuePriority.vue'
import Clock from './cfc/Clock.vue'
import Audio from './cfc/Audio.vue'
import Pencil from './cfc/Pencil.vue'
import Pin from './cfc/Pin.vue'

export const icons = {
  ManualSwitch,
  Voicemail,
  CallerID,
  QueuePriority,
  AddConnector,
  Clock,
  Pin,
  Audio,
  Pencil,
  Agent,
  AnalyticsIcon,
  AngleDoubleRightSolidIcon,
  AppDeviceIcon,
  Arrow,
  ArrowCircleLeftSolidIcon,
  Back,
  CalendarSwitch,
  CallForwardingIcon,
  CaretDownIcon,
  CaretDownSolidIcon,
  CaretUpSolidIcon,
  CatchAllIcon,
  CfcIcon,
  CheckCircleSolidIcon,
  Checkmark,
  CheckmarkInCircle,
  CheckSolidIcon,
  Chevron,
  ChevronLeft,
  ChevronRight,
  CloneIcon,
  Close,
  CloudIcon,
  CogSolidIcon,
  CollapseIcon,
  Copy,
  Cursor,
  Decrease,
  DectBaseDeviceIcon,
  DectHandsetDeviceIcon,
  Delete,
  DocumentFileRounded,
  DottedSpinner,
  EasybellLogo,
  EasyLogoIcon,
  EbCalling0Icon,
  EbCalling1Icon,
  EbConferenceIcon,
  EbFax2EmailIcon,
  EbQueueIcon,
  ErrorIcon,
  ErrorCircle,
  ExclamationTriangleSolidIcon,
  ExternalDeviceIcon,
  FacebookIcon,
  FilterIcon,
  Folder,
  Forward,
  Hand,
  Home,
  Increase,
  InfoIcon,
  InfoCircle,
  InstagramIcon,
  ItemsPlus,
  LinkedinIcon,
  MailIcon,
  ModuleBig,
  Modules,
  ModuleSmall,
  MultiEdit,
  MusicOnHoldIcon,
  NightSwitchIcon,
  Note,
  NotificationIcon,
  OfficeDeskIcon,
  PencilMini,
  PencilMiniActive,
  PenIcon,
  Phone,
  PhoneAltSolidIcon,
  Playback,
  TimeSwitch,
  Queue,
  PressDigit,
  PlayIcon,
  Plus,
  PlusCircleSolidIcon,
  PlusConnector,
  PlusSolidIcon,
  PrimaryDectBaseDeviceIcon,
  Question,
  Redo,
  RefreshIcon,
  RemoveColorIcon,
  SaveSolidIcon,
  Search,
  SecondaryDectBaseDeviceIcon,
  SelectAllIcon,
  Separator,
  SeparatorVertical,
  SettingsIcon,
  SignOutAltSolidIcon,
  StopIcon,
  SuccessIcon,
  SuccessCircle,
  TeamsDeviceIcon,
  ConnectMeDeviceIcon,
  TimesSolidIcon,
  TrashIcon,
  TrashSolidIcon,
  TwitterIcon,
  Undo,
  VoiceMailIcon,
  VoipDeviceIcon,
  WaitingMusicIcon,
  WaitLoopIcon,
  WarningIcon,
  WarningCircle,
  YoutubeIcon,
  Contacts,
  Lightbulb,
  KebabMenu,
  AddContactIcon,
  RemoveContactIcon,
  UploadContactsIcon,
  DownloadContactsIcon,
  EntraIcon,
  Spinner,
  FolderArrowUp,
  EbFqdnIcon
}

export type IconName = keyof typeof icons

export const iconNames = Object.keys(icons) as IconName[]
